/* Hair-family UI. Unconfirmed choices exist only in theme previews, never as order properties. */
(() => {
  'use strict';
  const family = value => {
    const normalized = String(value || '').trim().toLowerCase();
    if (normalized === 'raw' || normalized === 'raw hair') return 'raw';
    if (normalized === 'virgin' || normalized === 'virgin hair') return 'virgin';
    return '';
  };
  const label = value => family(value) === 'raw' ? 'Raw Hair' : family(value) === 'virgin' ? 'Virgin Hair' : 'Current listed specification';
  const exactVariant = (variants, options) => variants.find(v => v.options.length === options.length && v.options.every((value, i) => value === options[i]));
  if (typeof module !== 'undefined' && module.exports) { module.exports = { family, label, exactVariant }; return; }
  if (window.VessariqHairVersions) return;
  const states = new Map();
  const clean = () => {
    states.forEach((state, key) => {
      if (!state.native.isConnected || !state.picker.isConnected) {
        state.abort.abort();
        if (state.native.isConnected) {
          state.native.dataset.reviewRequired = state.originalReviewRequired;
          state.native.updateVariant?.(false);
        }
        states.delete(key);
      }
    });
  };
  const requested = () => family(new URL(location.href).searchParams.get('vq_hair'));
  function syncState(state) {
    const { native, picker, mode } = state;
    if (!native.isConnected || !picker.isConnected) return;
    if (mode === 'preview') {
      const selected = family(picker.querySelector('[data-vq-version-input]:checked')?.value);
      state.selected = selected;
      native.dataset.vqVersionPreview = selected ? 'true' : 'false';
      native.dataset.reviewRequired = selected ? 'true' : state.originalReviewRequired;
      const text = selected ? `${label(selected)} — preview only` : 'Not classified — current listed item';
      document.querySelectorAll('[data-vq-hair-spec]').forEach(node => { node.textContent = text; });
      picker.querySelector('[data-vq-version-summary]').textContent = text;
      picker.querySelector('[data-vq-version-reset]').hidden = !selected;
      const message = selected
        ? `${label(selected)} is a layout preview. Processing, availability and version price are not confirmed. Checkout is disabled for this preview selection.`
        : 'Preview selection cleared. The original listed SKU and its existing price apply; no Raw or Virgin claim is added.';
      picker.querySelector('[data-vq-version-status]').textContent = message;
      const status = native.querySelector('[data-vnp-status]');
      const bundleStatus = native.querySelector('[data-vq-bundle-status]');
      if (selected) {
        native.querySelectorAll('.vnp-form [type=submit],[data-vq-bundle-form] [type=submit]').forEach(button => { button.disabled = true; button.textContent = 'Preview only — version not confirmed'; });
        if (status) status.textContent = message;
        if (bundleStatus) bundleStatus.textContent = message;
      }
      const priceNote = native.querySelector('[data-vq-version-price-note]');
      if (priceNote) { priceNote.hidden = !selected; priceNote.textContent = 'Existing listing price shown for layout only; not a confirmed Raw / Virgin quote.'; }
    } else {
      const field = native.querySelector(`[data-option-index="${state.optionIndex}"]`);
      const selected = family(field?.querySelector('input:checked')?.value);
      document.querySelectorAll('[data-vq-hair-spec]').forEach(node => { node.textContent = selected ? label(selected) : 'See selected variant'; });
    }
  }
  function applyNativeRequest(state) {
    const desired = requested();
    if (!desired) return;
    const field = state.native.querySelector(`[data-option-index="${state.optionIndex}"]`);
    const input = [...(field?.querySelectorAll('input[type=radio]') || [])].find(control => family(control.value) === desired);
    if (!input) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    const selectedId = state.native.select?.value;
    const bundleSelect = state.native.querySelector('[data-vq-bundle-variant]');
    if (bundleSelect && [...bundleSelect.options].some(option => option.value === selectedId)) {
      bundleSelect.value = selectedId;
      bundleSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    syncState(state);
  }
  function mount(picker) {
    const native = document.querySelector('vessariq-native-product');
    if (!native || !native.form || !native.select || !picker.isConnected) return;
    const key = picker.dataset.productId;
    if (states.get(key)?.picker === picker) return;
    const previous = states.get(key);
    if (previous) { previous.abort.abort(); native.dataset.reviewRequired = previous.originalReviewRequired; if (previous.picker !== picker) previous.picker.remove(); }
    const state = { picker, native, mode: picker.dataset.mode, optionIndex: Number(picker.dataset.vqHairOptionIndex), selected: '', originalReviewRequired: native.dataset.reviewRequired || 'false', abort: new AbortController() };
    states.set(key, state);
    const listen = (node, event, callback) => node?.addEventListener(event, callback, { signal: state.abort.signal });
    const original = native.querySelector('.vnp-form');
    const bundleForm = native.querySelector('[data-vq-bundle-form]');
    const target = bundleForm && original.hidden ? bundleForm : native.querySelector('.vnp-specification-content') || original;
    if (state.mode === 'preview') {
      target.prepend(picker);
      const inputs = [...picker.querySelectorAll('[data-vq-version-input]')];
      inputs.forEach(input => { input.disabled = false; input.checked = input.value === (requested() || 'virgin'); });
      picker.querySelector('[data-vq-version-reset]').hidden = false;
      listen(picker, 'change', event => {
        if (!event.target.matches('[data-vq-version-input]')) return;
        const url = new URL(location.href); url.searchParams.set('vq_hair', event.target.value); history.replaceState({}, '', url);
        syncState(state);
      });
      listen(picker.querySelector('[data-vq-version-reset]'), 'click', () => {
        inputs.forEach(input => { input.checked = false; });
        native.dataset.reviewRequired = state.originalReviewRequired;
        const url = new URL(location.href); url.searchParams.delete('vq_hair'); history.replaceState({}, '', url);
        native.updateVariant?.(false);
        if (bundleForm) bundleForm.dispatchEvent(new Event('change', { bubbles: true }));
        syncState(state);
      });
      let note = native.querySelector('[data-vq-version-price-note]');
      if (!note) { note = document.createElement('p'); note.dataset.vqVersionPriceNote = ''; note.className = 'vq-version-price-note'; native.querySelector('.vnp-price')?.after(note); }
      listen(window, 'popstate', () => {
        const desired = requested(); inputs.forEach(input => { input.checked = input.value === desired; });
        native.dataset.reviewRequired = desired ? 'true' : state.originalReviewRequired;
        native.updateVariant?.(false);
        if (bundleForm) bundleForm.dispatchEvent(new Event('change', { bubbles: true }));
        syncState(state);
      });
      native.dataset.reviewRequired = 'true';
      native.updateVariant?.(false);
    } else if (state.mode === 'native') {
      const field = native.querySelector(`[data-option-index="${state.optionIndex}"]`);
      // Preserve native DOM option order: the existing variant resolver relies on it.
      if (field) field.querySelector('legend').textContent = 'Hair Type';
      picker.hidden = true;
      applyNativeRequest(state);
      listen(window, 'popstate', () => queueMicrotask(() => applyNativeRequest(state)));
    }
    listen(native, 'change', () => queueMicrotask(() => syncState(state)));
    syncState(state);
  }
  function init() {
    clean();
    if (!customElements.get('vessariq-native-product') && !document.querySelector('vessariq-native-product')) return;
    customElements.whenDefined('vessariq-native-product').then(() => {
      document.querySelectorAll('[data-vq-hair-versions]').forEach(mount);
    });
  }
  document.addEventListener('submit', event => {
    const native = event.target.closest?.('vessariq-native-product');
    const state = native && states.get(native.dataset.productId);
    if (!state || state.mode !== 'preview' || !state.selected || !event.target.matches('.vnp-form,[data-vq-bundle-form]')) return;
    event.preventDefault(); event.stopImmediatePropagation(); syncState(state);
    state.picker.querySelector('[data-vq-version-status]')?.focus();
  }, true);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(clean));
  window.VessariqHairVersions = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
